module.exports = "<vue-component class=\"tr-page__wrapper\" component=\"Page404\" v-props=\"currentParams\"></vue-component>\n\n"